import Vue, { PropType } from "vue";
import OS from "js/framework/utils/OS";
import { formatTimeHMS } from "js/crossword/helpers/dateHelpers";
import { Provider } from "js/crossword/types";

import commonStyles from "../css/common.module.css";

interface ICalendarProgress {
  completed: number | string;
  rate: number;
  rateLabel: string;
  time: number;
  timeLabel: string;
}

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  props: {
    data: Object as PropType<ICalendarProgress>,
  },
  computed: {
    time(): string {
      return formatTimeHMS(Math.floor(this.data.time / 1000));
    },
  },
  render() {
    return (
      <div class='calendarProgressPanel'>
        <div
          class='calendarProgressPanel__item'
          title={this.localization.get("Average solve time excludes puzzles for which ‘reveal the whole puzzle’ function was used.")}
        >
          <div class='calendarProgressPanel__itemMainValue'>{this.time}</div>
          <div class={{ "calendarProgressPanel__label--mobile": !OS.desktop }}>
            {this.data.timeLabel}
          </div>
        </div>

        <div class='calendarProgressPanel__separator'></div>

        <div class='calendarProgressPanel__item'>
          <div class='calendarProgressPanel__itemMainValue'>{(this.data.rate * 100).toFixed(2)}%</div>
          <div class={{ "calendarProgressPanel__label--mobile": !OS.desktop }}>
            {this.data.rateLabel}
          </div>
        </div>

        <div class='calendarProgressPanel__separator'></div>

        <div class='calendarProgressPanel__item'>
          <div class='calendarProgressPanel__itemMainValue'>
            <img src='images/Star_Full.svg' class='calendarProgressPanel__starIcon' />
            <span>{this.data.completed}</span>
          </div>
          <div
            class={{
              [commonStyles.lineBreakEnabled]: true,
              "calendarProgressPanel__label--mobile": !OS.desktop,
            }}>
              {this.localization.get("Crosswords solved\nthis month")}
            </div>
        </div>
      </div>
    );
  },
});
